import { SVGProps } from "react";
const LockSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      stroke="#7D8690"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.333 6.667v-2 0A2.667 2.667 0 0 1 8 2v0a2.667 2.667 0 0 1 2.666 2.667v2"
    />
    <path
      fill="#7D8690"
      fillRule="evenodd"
      stroke="#7D8690"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.333 14H4.666a1.333 1.333 0 0 1-1.333-1.333V8c0-.736.597-1.333 1.333-1.333h6.667c.737 0 1.333.597 1.333 1.333v4.667c0 .737-.596 1.333-1.333 1.333Z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 9.333v2"
    />
  </svg>
);
export default LockSvg;
